import { useCallback } from 'react';
import { Typography, Button, Grid, Stack, Box } from '@mui/material';
import dayjs from 'dayjs';
import Model from '../models/model';
import strings from '../Globalization/index';
import TagActivityTable from './TagActivityTable';

const StartDateFilter = ({ Input, inputProps }) => {
	const handleBtnClick = useCallback(() => {
		if (!inputProps?.formik?.values?.startDateTime) {
			inputProps?.setFieldValue('startDateTime', dayjs());
		}
	}, [inputProps?.formik?.values?.startDateTime]);

	return (
		<Stack flex={1} direction="row" spacing={1}>
			<Box display={'flex'} alignItems={'center'}>
				<Button
					onClick={handleBtnClick}
					variant="contained"
					sx={{ backgroundColor: '#23c6c8', width: theme => theme.spacing(12), '&:hover': { backgroundColor: '#199091' } }}
					disableElevation
				>
					{strings.Start}
				</Button>
				</Box>
			<Box display={'flex'} alignItems={'center'}>
			<Input {...inputProps} />
				</Box>
				
		
			<Box sx={{ width: theme => theme.spacing(12) }} />
		</Stack>
	);
};

const StopDateFilter = ({ Input, inputProps }) => {
	const handleBtnClick = useCallback(() => {
		if (!inputProps?.formik?.values?.endDateTime) {
			inputProps?.setFieldValue('endDateTime', dayjs());
		}
	}, [inputProps?.formik?.values?.endDateTime, inputProps?.formik?.values?.startDateTime]);
	return (
		<Stack flex={1} direction="row" alignItems={'center'} spacing={1}>
			<Box display={'flex'} alignItems={'center'}>
			<Button
					onClick={handleBtnClick}
					variant="contained"
					sx={{ backgroundColor: '#f8996b', width: theme => theme.spacing(12), '&:hover': { backgroundColor: '#d4815b' } }}
					disableElevation
					disabled={!inputProps?.formik?.values?.startDateTime}
				>
					{strings.Stop}
				</Button>
				</Box>
				<Box>
			<Input {...inputProps} />
				</Box>
		
				<Button
					onClick={() => {
						inputProps?.formik?.setFieldValue('startDateTime', null);
						inputProps?.formik?.setFieldValue('endDateTime', null);
						inputProps?.formik?.handleSubmit();
					}}
					variant="contained"
					sx={{ backgroundColor: '#a49f9d', '&:hover': { backgroundColor: '#807f7e' } }}
					disableElevation
				>
					{strings.Clear}
				</Button>
		</Stack>
		
	);
};
const model = new Model({
	name: 'Antenna',
	gridTitle: 'MonitoringByTag',
	gridToolbarHeight: 216,
	disableAdd: true,
	disableDelete: true,
	formTitleField: 'tagId',
	idProperty: 'tagId',
	defaultSort: 'lastSeenDateTime DESC',
	headerFilterApplyTrigger: 'onChange',
	title: 'Tags',
	disablePagination: true,
	showGridRefreshBtn: true,
	readOnly: true,
	relations: [
		{
			relation: TagActivityTable,
			column: 'tagId',
			getParentFilters: ({ record, standaloneFilters }) => ({
				filter: [
					{ operator: 'eq', value: record.tagId, property: 'tagId', type: 'numeric' },
					...(standaloneFilters.startDateTime
						? [
							{
								operator: 'eq',
								value: standaloneFilters.startDateTime,
								property: 'startDateTime',
								type: 'datetime'
							}
						]
						: []),
					...(standaloneFilters.endDateTime
						? [
							{
								operator: 'eq',
								value: standaloneFilters.endDateTime,
								property: 'endDateTime',
								type: 'datetime'
							}
						]
						: [])
				]
			}),
			title: ({ record }) => {
				return record?.tagId ? `- ${record?.tagId}` : '';
			}
		}
	],
	columns: [
		{ header: 'AssetName', field: 'assetName', type: 'array', width: 250 },
		{
			header: 'TagID',
			field: 'tagId',
			width: 300,
			renderCell: (params) => {
				return (
					<Typography color="primary.dark" underline component="u">
						{params.row?.tagId}
					</Typography>
				);
			}
		},
		{ header: 'Antenna', field: 'antennaName', width: 300 },
		{ header: 'Count', field: 'count', width: 150, type: 'action' },
		{
			header: 'LastRead',
			field: 'lastSeenDateTime',
			width: 265,
			type: 'dateTime',
			isLocal: true,
			filterType: 'dateTime'
		},
		{ header: 'Rssi', field: 'peakRSSI', width: 150 },
		{ header: 'Type', field: 'assetType', width: 150 },

		{
			header: 'StartDate',
			field: 'startDateTime',
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'dateTime',
			filterColSize: 7,
			isNotformfield: true,
			maxDate: ({ formik }) => (formik.values.endDateTime ? dayjs(formik.values.endDateTime) : undefined),
			inputProps: {
				views: ['year', 'month', 'day', 'hours', 'minutes', 'seconds']
			},
			customizeInput: StartDateFilter,
			hide: true
		},
		{
			header: 'EndDate',
			field: 'endDateTime',
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'dateTime',
			minDate: ({ formik }) => (formik.values.startDateTime ? dayjs(formik.values.startDateTime) : undefined),
			isNotformfield: true,
			filterColSize: 7,
			inputWrapperProps: {
				sx: { width: (theme) => theme.spacing(50) }
			},
			inputProps: {
				views: ['year', 'month', 'day', 'hours', 'minutes', 'seconds']
			},
			customizeInput: StopDateFilter,
			hide: true
		}
	]
});

export default model.createFormBase();
